import { render, staticRenderFns } from "./SitesTable.vue?vue&type=template&id=37307b5a"
import script from "./SitesTable.vue?vue&type=script&lang=js"
export * from "./SitesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports